(() => {
  'use strict';
  const FEED = 'https://kachang-hub.onrender.com/public/events.json';
  // Identity, not titles or legacy URL slugs, defines this seven-date programme.
  const SERIES = new Map([
    ['owned-7edeae7924f74acd8f5ca06cce759978', 'training'],
    ['owned-18887eeb532b4529a17afc89dcde74ec', 'training'],
    ['owned-a86c593961424139ab811cec67db70de', 'race'],
    ['owned-e36411287005487ab2a98b1a33d4624b', 'training'],
    ['owned-d10370199f4048d5a12c8a514bdc9488', 'race'],
    ['owned-629a86dab835456da660af8e11c68726', 'training'],
    ['owned-41b337ecc97e49a985dce971edfff05e', 'race']
  ]);
  const local = (value, lang) => typeof value === 'object' && value
    ? String(value[lang] || value.en || value.id || '') : String(value || '');
  function zone(event) {
    try { new Intl.DateTimeFormat('en', { timeZone: event.timezone || 'Asia/Jakarta' }); return event.timezone || 'Asia/Jakarta'; }
    catch { return 'Asia/Jakarta'; }
  }
  function localDate(value, event) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return value;
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: zone(event), year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(value));
    return ['year', 'month', 'day'].map(key => parts.find(p => p.type === key).value).join('-');
  }
  function status(event, now = new Date()) {
    if (event.cancelled) return 'cancelled';
    if (event.end && String(event.end).length > 10
      ? now >= new Date(event.end)
      : localDate(now, event) > localDate(event.last_date || event.end || event.start, event)) return 'past';
    if (event.registration_closes) {
      const deadline = String(event.registration_closes);
      if (!Number.isFinite(Date.parse(deadline))) return 'check';
      if (deadline.length === 10 ? localDate(now, event) > deadline : now >= new Date(deadline)) return 'closed';
    }
    return ['open', 'closed', 'sold_out', 'soon', 'cancelled'].includes(event.registration) ? event.registration : 'check';
  }
  function bookingUrl(event, lang) {
    try {
      const url = new URL(event.booking_url || event.tickets);
      const keys = [...url.searchParams.keys()];
      if (!['https://www.technicaloutdoor.com', 'https://technicaloutdoor.com'].includes(url.origin)
        || url.username || url.password || url.hash
        || !/^\/(?:en\/)?pages\/event-registration$/.test(url.pathname)
        || keys.some(key => !['event', 'occurrence', 'lang'].includes(key)) || new Set(keys).size !== keys.length
        || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(url.searchParams.get('event') || '')
        || 'owned-' + url.searchParams.get('occurrence') !== event.id) return '';
      url.pathname = (lang === 'en' ? '/en' : '') + '/pages/event-registration';
      url.searchParams.set('lang', lang);
      return url.href;
    } catch { return ''; }
  }
  function price(event, lang) {
    if (event.price === undefined) return lang === 'en' ? 'Free' : 'Gratis';
    const p = event.price;
    return p && p.currency === 'IDR' && p.per === 'participant' && typeof p.amount === 'number' && Number.isFinite(p.amount) && p.amount > 0
      ? 'Rp' + new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'id-ID').format(p.amount) : '';
  }
  function seriesEvents(feed) {
    if (!feed || feed.schemaVersion !== 1 || !Array.isArray(feed.events) || feed.truncated) throw new Error('Invalid event list');
    const ids = new Set();
    return feed.events.filter(e => e && SERIES.has(e.id)).map(e => {
      if (ids.has(e.id) || e.ownership !== 'technical_outdoor' || !Number.isFinite(Date.parse(e.start))) throw new Error('Invalid series event');
      ids.add(e.id);
      return e;
    }).sort((a, b) => Date.parse(a.start) - Date.parse(b.start));
  }
  const PACKAGE = 'selektad-2026';
  function packageOffer(events, unit, lang, now = new Date()) {
    const races = events.filter(e => SERIES.get(e.id) === 'race');
    if (races.length !== 3 || new Set(races.map(e => e.id)).size !== 3
      || races.some(e => status(e, now) !== 'open' || !bookingUrl(e, lang)
        || !e.price || e.price.currency !== 'IDR' || e.price.per !== 'participant'
        || !Number.isSafeInteger(e.price.amount) || e.price.amount <= 0)
      || !/^[1-9]\d*$/.test(String(unit)) || !Number.isSafeInteger(Number(unit))) return null;
    const url = new URL(bookingUrl(races[0], lang));
    url.searchParams.set('package', PACKAGE);
    return { url: url.href, amount: Number(unit), separate: races.reduce((sum, e) => sum + e.price.amount, 0) };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { SERIES, seriesEvents, status, bookingUrl, price, localDate, packageOffer };
    return;
  }
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  for (const root of document.querySelectorAll('[data-selektad]')) {
    if (root.dataset.ready) continue;
    root.dataset.ready = 'true';
    const lang = root.dataset.language === 'en' ? 'en' : 'id';
    const tr = (en, id) => lang === 'en' ? en : id;
    const locale = lang === 'en' ? 'en-GB' : 'id-ID';
    const list = root.querySelector('[data-st-events]');
    const notice = root.querySelector('[data-st-status]');
    const retry = root.querySelector('[data-st-retry]');
    const filters = root.querySelector('.st-filters');
    const count = root.querySelector('[data-st-count]');
    const packageBook = root.querySelector('[data-st-package-book]');
    const packagePrice = root.querySelector('[data-st-package-price]');
    const packagePer = root.querySelector('[data-st-package-per]');
    const packageSaving = root.querySelector('[data-st-package-saving]');
    const packageStatus = root.querySelector('[data-st-package-status]');
    const packageDates = root.querySelector('[data-st-package-dates]');
    const states = lang === 'en'
      ? { closed: 'Registration closed', sold_out: 'Sold out', soon: 'Opening soon', past: 'Event ended', cancelled: 'Cancelled', check: 'Check registration details' }
      : { closed: 'Pendaftaran ditutup', sold_out: 'Kuota penuh', soon: 'Segera dibuka', past: 'Acara selesai', cancelled: 'Dibatalkan', check: 'Cek detail pendaftaran' };
    let events = [], filter = 'all', loading = false, signature = '';
    function card(event, now) {
      const state = status(event, now);
      const article = node('article', 'st-event');
      article.dataset.kind = SERIES.get(event.id);
      article.dataset.state = state;
      article.dataset.eventId = event.id;
      const date = localDate(event.start, event);
      const dateNode = node('time', 'st-date');
      dateNode.dateTime = date;
      dateNode.setAttribute('aria-label', new Intl.DateTimeFormat(locale, { dateStyle: 'full', timeZone: 'UTC' }).format(new Date(date + 'T12:00:00Z')));
      dateNode.append(node('span', 'st-date-month', new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(new Date(date + 'T12:00:00Z'))), node('span', 'st-date-day', date.slice(8)), node('span', 'st-date-year', date.slice(0, 4)));
      const body = node('div', 'st-body');
      body.append(node('span', 'st-tag', SERIES.get(event.id) === 'training' ? tr('Road to SelekTAD · Free training', 'Road to SelekTAD · Latihan gratis') : tr('SelekTAD · Selection race', 'SelekTAD · Lomba seleksi')));
      body.append(node('h3', '', local(event.title_i18n || event.title, lang)));
      const meta = [local(event.time, lang), local(event.venue_i18n || event.venue, lang)].filter(Boolean).join(' · ');
      body.append(node('p', 'st-meta', meta));
      const details = node('details', 'st-details');
      details.append(node('summary', '', tr('Event details', 'Detail acara')), node('p', '', local(event.details || event.summary, lang)));
      let poster;
      try {
        const image = new URL(event.image);
        if (image.origin === 'https://kachang-hub.onrender.com' && image.pathname.startsWith('/events/poster/') && !image.username && !image.password) {
          poster = node('a', 'st-poster');
          poster.href = image.href; poster.target = '_blank'; poster.rel = 'noopener noreferrer';
          poster.setAttribute('aria-label', tr('View full poster — ', 'Lihat poster lengkap — ') + local(event.title_i18n || event.title, lang));
          const img = node('img');
          img.src = image.href; img.alt = local(event.title_i18n || event.title, lang); img.loading = 'lazy'; img.width = 360; img.height = 450;
          poster.append(img);
          article.dataset.poster = 'true';
        }
      } catch { /* An event can have no poster. */ }
      body.append(details);
      const action = node('div', 'st-action');
      const amount = price(event, lang);
      if (amount) action.append(node('span', 'st-price', amount), node('span', 'st-per', tr('per participant', 'per peserta')));
      const url = bookingUrl(event, lang);
      if (url && ['open', 'check'].includes(state)) {
        const button = node('a', 'st-book', state === 'open'
          ? SERIES.get(event.id) === 'training' ? tr('Join free training', 'Daftar latihan gratis') : tr('Book this race', 'Daftar lomba ini')
          : tr('View details', 'Lihat detail'));
        button.href = url;
        button.setAttribute('aria-label', button.textContent + ' — ' + local(event.title_i18n || event.title, lang));
        const arrow = node('span', '', '↗'); arrow.setAttribute('aria-hidden', 'true'); button.append(arrow);
        action.append(button);
      }
      if (state !== 'open' || !url) action.append(node('span', 'st-state', states[state] || tr('Booking unavailable', 'Pendaftaran belum tersedia')));
      article.append(dateNode, body, action);
      if (poster) article.append(poster);
      return article;
    }
    function clearPackage(message) {
      packageBook.hidden = packagePrice.hidden = packagePer.hidden = packageSaving.hidden = true;
      packageBook.removeAttribute('href');
      packagePrice.textContent = packageSaving.textContent = '';
      packageStatus.hidden = false;
      packageStatus.textContent = message;
    }
    async function refreshPackage() {
      clearPackage(tr('Checking package availability…', 'Mengecek ketersediaan paket…'));
      const races = events.filter(e => SERIES.get(e.id) === 'race');
      packageDates.textContent = races.map(e => new Intl.DateTimeFormat(locale, {
        day: 'numeric', month: 'short', year: 'numeric', timeZone: zone(e)
      }).format(new Date(e.start))).join(' · ');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        if (!packageOffer(events, 1, lang)) throw new Error('Package races unavailable');
        const first = new URL(bookingUrl(races[0], lang));
        const path = '/events/' + first.searchParams.get('event') + '?occurrence='
          + first.searchParams.get('occurrence') + '&lang=' + lang;
        // Read the existing anonymous form. The Hub remains the price and availability authority.
        const response = await fetch('https://kachang-hub.onrender.com/public/event-registration', {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error',
          referrerPolicy: 'no-referrer', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ path, method: 'GET', fields: {}, state: null })
        });
        if (!response.ok) throw new Error('Package unavailable');
        const data = await response.json();
        if (data.status !== 200 || typeof data.html !== 'string') throw new Error('Package unavailable');
        const parsed = new DOMParser().parseFromString(data.html, 'text/html');
        const options = parsed.querySelectorAll('main.oe input[type="radio"][name="registration_option"][value="' + PACKAGE + '"]');
        if (options.length !== 1 || options[0].matches(':disabled')) throw new Error('Package unavailable');
        const offer = packageOffer(events, options[0].dataset.oeUnit, lang);
        if (!offer) throw new Error('Package unavailable');
        const money = amount => 'Rp' + new Intl.NumberFormat(locale).format(amount);
        packagePrice.textContent = money(offer.amount);
        packageBook.href = offer.url;
        packageBook.hidden = packagePrice.hidden = packagePer.hidden = false;
        const saving = offer.separate - offer.amount;
        packageSaving.textContent = tr(`${money(offer.separate)} separately · Save ${money(saving)}`, `Daftar satuan ${money(offer.separate)} · Hemat ${money(saving)}`);
        packageSaving.hidden = saving <= 0;
        packageStatus.hidden = true;
      } catch {
        clearPackage(tr('The package is currently unavailable. Check individual events below.', 'Paket belum tersedia. Kamu bisa melihat pilihan lomba satuan di bawah.'));
      } finally { clearTimeout(timeout); }
    }
    function render() {
      const now = new Date();
      const nextSignature = JSON.stringify([filter, events, events.map(e => status(e, now))]);
      if (signature === nextSignature) return;
      signature = nextSignature;
      const expanded = new Set([...list.querySelectorAll('details[open]')].map(el => el.closest('[data-event-id]').dataset.eventId));
      const shown = events.filter(e => filter === 'all' || SERIES.get(e.id) === filter);
      list.replaceChildren(...shown.map(e => {
        const element = card(e, now);
        if (expanded.has(e.id)) element.querySelector('details').open = true;
        return element;
      }));
      count.textContent = tr(`${shown.length} of ${events.length} events`, `${shown.length} dari ${events.length} acara`);
      notice.hidden = shown.length > 0;
      notice.textContent = tr('No published events in this selection.', 'Belum ada jadwal untuk pilihan ini.');
    }
    async function refresh() {
      if (loading || !root.isConnected) return;
      loading = true; retry.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(FEED, { mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Event list unavailable');
        events = seriesEvents(await response.json());
        filters.hidden = false;
        render();
        await refreshPackage();
      } catch {
        // Withdraw stale links when the current published list cannot be verified.
        events = []; signature = ''; list.replaceChildren(); count.textContent = ''; filters.hidden = true;
        notice.hidden = false;
        notice.textContent = tr('We could not load the latest events. Please try again.', 'Acara terkini tidak dapat dimuat. Silakan coba lagi.');
        retry.hidden = false;
        packageDates.textContent = '';
        clearPackage(tr('Package availability could not be checked. Try loading the events again.', 'Ketersediaan paket belum dapat diperiksa. Coba muat acara kembali.'));
      } finally { clearTimeout(timeout); loading = false; }
    }
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-st-filter]');
      if (!button) return;
      filter = button.dataset.stFilter;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      render();
    });
    retry.addEventListener('click', refresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    setInterval(() => { if (!document.hidden) refresh(); }, 60000);
    refresh();
  }
})();
